import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Subtle haptic feedback for primary tap targets (bottom nav, FABs, CTAs).
 *
 * - Uses the Vibration API which is widely supported on Android and silently
 *   ignored everywhere else (iOS Safari, all desktop browsers).
 * - 8ms is intentionally short — long enough to feel "native-app-like" on a
 *   home-screen-installed PWA, short enough to avoid feeling buzzy.
 * - We honour `prefers-reduced-motion` because some users disable vibration
 *   for accessibility reasons; the same OS-level setting maps to that media
 *   query on Android.
 */
export function tapFeedback(durationMs = 8) {
  if (typeof window === "undefined" || typeof navigator === "undefined") return;
  if (typeof navigator.vibrate !== "function") return;
  try {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }
    navigator.vibrate(durationMs);
  } catch {
    /* ignore — non-fatal */
  }
}
